export default function FunctionsSection() {
  const functions = [
    {
      tag: '核心',
      icon: 'ri-folder-upload-line',
      title: '智能文件上传',
      price: '批量上传 / 断点续传',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cloud%20file%20upload%20interface%20with%20drag%20and%20drop%20area%2C%20clean%20minimal%20dashboard%20design%2C%20soft%20beige%20background%2C%20professional%20SaaS%20UI%2C%20progress%20indicators%2C%20clean%20typography&width=600&height=500&seq=func-upload-fs&orientation=landscape',
    },
    {
      icon: 'ri-search-eye-line',
      title: '全文检索搜索',
      price: '毫秒级 / OCR识别',
      imageUrl: 'https://readdy.ai/api/search-image?query=File%20search%20interface%20with%20magnifying%20glass%20icon%20and%20document%20thumbnails%2C%20minimalist%20UI%20design%2C%20clean%20beige%20background%2C%20corporate%20SaaS%20style%2C%20filter%20options%2C%20search%20results%20list&width=600&height=500&seq=func-search-fs&orientation=landscape',
    },
    {
      icon: 'ri-lock-password-line',
      title: '精细化权限',
      price: '角色管理 / 水印保护',
      imageUrl: 'https://readdy.ai/api/search-image?query=Security%20permission%20settings%20panel%20with%20role-based%20access%20controls%2C%20lock%20icons%2C%20modern%20dashboard%20interface%2C%20clean%20minimal%20design%2C%20soft%20warm%20background%2C%20professional%20atmosphere&width=600&height=500&seq=func-permission-fs&orientation=landscape',
    },
    {
      icon: 'ri-file-copy-2-line',
      title: '多格式预览',
      price: '100+ 格式 / 在线编辑',
      imageUrl: 'https://readdy.ai/api/search-image?query=Document%20preview%20interface%20showing%20PDF%20and%20office%20documents%2C%20minimal%20modern%20design%2C%20clean%20beige%20background%2C%20corporate%20SaaS%20style%2C%20thumbnail%20gallery%20of%20different%20file%20types&width=600&height=500&seq=func-preview-fs&orientation=landscape',
    },
  ];

  return (
    <section id="functions" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-label text-xs md:text-sm font-medium tracking-widest text-foreground-500 uppercase mb-3">
            核心功能
          </p>
          <h3 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            强大的<span className="italic">文件处理</span>能力
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {functions.map((func, index) => (
            <div
              key={index}
              className="rounded-2xl bg-background-100 overflow-hidden border border-background-200/70 flex flex-col hover:scale-[1.02] transition-transform duration-300"
            >
              {func.tag && (
                <div className="px-4 pt-4">
                  <span className="inline-block px-3 py-1 rounded-lg bg-accent-100 text-accent-700 text-xs font-medium">
                    {func.tag}
                  </span>
                </div>
              )}
              <div className="px-4 pt-4">
                <div className="w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                  <img
                    src={func.imageUrl}
                    alt={func.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="p-4 pt-3">
                <h4 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 text-center">
                  {func.title}
                </h4>
                <p className="text-foreground-500 text-xs md:text-sm text-center mt-1">
                  {func.price}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}